import React from 'react';
import { ToastWrapper } from 'src/common/components/Toast';
import styled from 'styled-components';

const Paragraph = styled.p`
  text-align: center;
`;

export const RedirectionToChannelToast: React.FC = () => (
  <ToastWrapper kind="primary">
    <Paragraph>
      Wystąpił błąd w trakcie połączenia z bankiem. <br /> Ponawiamy połączenie.
    </Paragraph>
  </ToastWrapper>
);
